<template>
  <div id="data-list-list-view" class="data-list-container">
     <trainee-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" />
    <coaching-experience-sidebar
      :isSidebarActive="addNewDataSidebarCoaching"
      @closeSidebar="toggleDataSidebarCoaching"
    />
    <vs-popup fullscreen :title="$t('Schedules')" :active.sync="calenderPopup" >
      <div id="simple-calendar-app" >
        <div class=" no-scroll-content">
          <calendar-view
              ref="calendar"
              :displayPeriodUom="calendarView"
              :show-date="showDate"
              :events="eventsData"
              enableDragDrop
              timeFormat="h:mm a"
              :eventTop="windowWidth <= 400 ? '2rem' : '3rem'"
              eventBorderHeight="2px"
              eventContentHeight="1.85rem"
              class="theme-default custom-calendar-view"
              style="padding:10px"
              @click-date="promptAddMeeting"
              @click-day="promptAddMeeting"
              @drop-on-date="eventDragged">

            <div slot="header" class="mb-4">
              <div class="vx-row no-gutter">
                <!-- Month Name -->
                <div class="vx-col w-1/3 items-center sm:flex hidden">
                  <template v-for="(view, index) in calendarViewTypes">
                    <vs-button
                        v-if="calendarView === view.val"
                        :key="String(view.val) + 'filled'"
                        type="filled"
                        class="p-3 md:px-8 md:py-3"
                        :class="{'border-l-0 rounded-l-none': index, 'rounded-r-none': calendarViewTypes.length !== index+1}"
                        @click="calendarView = view.val"
                    >{{ view.label }}</vs-button>
                    <vs-button
                        v-else
                        :key="String(view.val) + 'border'"
                        type="border"
                        class="p-3 md:px-8 md:py-3"
                        :class="{'border-l-0 rounded-l-none': index, 'rounded-r-none': calendarViewTypes.length !== index+1}"
                        @click="calendarView = view.val"
                    >{{ view.label }}</vs-button>
                  </template>
                </div>

                <!-- Current Month -->
                <div class="vx-col sm:w-1/3 w-full sm:my-0 my-3 flex sm:justify-end justify-center order-last">
                  <div class="flex items-center">
                    <feather-icon
                        :icon="$vs.rtl ? 'ChevronRightIcon' : 'ChevronLeftIcon'"
                        @click="updateMonth(-1)"
                        svgClasses="w-5 h-5 m-1"
                        class="cursor-pointer bg-primary text-white rounded-full" />
                    <span class="mx-3 text-xl font-medium whitespace-no-wrap">{{ showDate | month }}</span>
                    <feather-icon
                        :icon="$vs.rtl ? 'ChevronLeftIcon' : 'ChevronRightIcon'"
                        @click="updateMonth(1)"
                        svgClasses="w-5 h-5 m-1"
                        class="cursor-pointer bg-primary text-white rounded-full" />
                  </div>
                </div>

                <!-- NEW: Added Meeting icon to Legend -->
                <div class="vx-col sm:w-1/3 w-full flex justify-center">
                  <feather-icon icon="CircleIcon" title='Skill not added' :svgClasses="['fill-current h-4 w-4', 'text-danger']" />
                  <feather-icon icon="CircleIcon" title='Start working on' :svgClasses="['fill-current h-4 w-4', 'text-primary']" class="ml-4"/>
                  <feather-icon icon="CircleIcon" title='Goal Achieved' :svgClasses="['fill-current h-4 w-4', 'text-success']" class="ml-4"/>
                  <feather-icon icon="CircleIcon" title='Meeting Scheduled' :svgClasses="['fill-current h-4 w-4', 'text-warning']" class="ml-4"/>
                </div>
              </div>

              <div class="vx-row sm:flex hidden mt-4">
                <div class="vx-col w-full flex">
                  <!-- Labels -->
                  <div class="flex flex-wrap sm:justify-start justify-center">
                    <div v-for="(label, index) in calendarLabels" :key="index" class="flex items-center mr-4 mb-2">
                      <div class="h-3 w-3 inline-block rounded-full mr-2" :class="'bg-' + label.color"></div>
                      <span>{{ label.text }}</span>
                    </div>
                    <!--                <div class="flex items-center mr-4 mb-2">-->
                    <!--                  <div class="h-3 w-3 inline-block rounded-full mr-2 bg-primary"></div>-->
                    <!--                  <span>None</span>-->
                    <!--                </div>-->
                  </div>
                </div>
              </div>
            </div>
          </calendar-view>
        </div>

        <!-- SCHEDULE MEETING POPUP -->
        <vs-popup 
          class="calendar-event-dialog meeting-popup" 
          :title="'Schedule Meeting with ' + currentTraineeName" 
          :active.sync="activePromptAddMeeting" 
          style="z-index: 100000;">
          
          <div class="relative mt-1 p-2">
            
            <!-- Time Inputs -->
            <div class="flex justify-between my-2">
              <label class="mt-2 mr-1 align-middle label fix-label text-left font-semibold">Start Time</label>
              <div class="vx-row w-full m-0">
                <div class="vx-col w-1/2 p-0 pr-2">
                  <vs-input v-model.number="startH" type="number" color="warning" :min="0" :max="23" placeholder="HH" class="w-full" />
                </div>
                <div class="vx-col w-1/2 p-0 pl-2">
                  <vs-input v-model.number="startM" type="number" color="warning" :min="0" :max="59" placeholder="MM" class="w-full" />
                </div>
              </div>
            </div>

            <!-- Timezone -->
            <div class="flex justify-between my-2">
              <label class="mt-2 mr-1 align-middle label fix-label text-left font-semibold">Time Zone</label>
              <select class="selectType w-full dropdown timezone-select p-2 border rounded border-grey-light text-primary" v-model="timezone">
                <optgroup label="Most Used Timezone">
                  <option value="Asia/Kolkata">Asia/Calcutta</option>
                  <option value="Europe/Lisbon">Europe/Lisbon</option>
                  <option value="GMT">GMT</option>
                </optgroup>
                <optgroup label="All Timezones">
                  <option value="America/New_York">America/New_York</option>
                  <option value="America/Los_Angeles">America/Los_Angeles</option>
                  <option value="Europe/London">Europe/London</option>
                  <option value="Asia/Dubai">Asia/Dubai</option>
                  <option value="Australia/Sydney">Australia/Sydney</option>
                </optgroup>
              </select>
            </div>

            <!-- Meeting Date (Fixed with proper props) -->
            <div class="flex justify-between my-2">
              <label class="mt-2 mr-1 align-middle label fix-label text-left font-semibold">Meeting Date</label>
              <datepicker id="weekend-datetime-picker"
                v-model="meetingDate"
                name="meetingDate"
                class="text-primary bg-none w-full border rounded p-1"
                :value="meetingDate"
                :format="DatePickerFormat"
                :disabledDates="disabledDates"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"></datepicker>
            </div>

            <!-- Use My Meeting Link -->
            <div class="flex justify-between my-2 items-center">
              <label class="mt-2 mr-1 align-middle label fix-label text-left text-sm font-semibold">Use My Meeting Link?</label>
              <div class="flex items-center w-full mt-2">
                <vs-switch v-model="useMyMeetingLink" class="mr-2" color="success" />
                <span v-if="useMyMeetingLink" class="text-sm text-grey truncate opacity-75 ml-2" style="max-width: 170px;">
                  <i v-if="myMeetingLink">{{ myMeetingLink }}</i>
                  <i v-else>No link saved</i>
                </span>
              </div>
            </div>

            <!-- Custom Link -->
            <div v-if="!useMyMeetingLink" class="flex justify-between my-2">
              <label class="mt-2 mr-1 align-middle label fix-label text-left font-semibold">Meeting Link</label>
              <vs-input v-model="meetingUrl" class="w-full text-primary" placeholder="Optional (e.g. abc.com)" />
            </div>

            <!-- Message -->
            <div class="relative mt-4">
              <vs-textarea v-model="msg" class="w-full resize-none" placeholder="Meeting Purpose" rows="3" />
            </div>

            <!-- Save Button -->
            <div class="flex justify-center mt-4">
              <vs-button class="primary mr-1 my-1 w-full" color="warning" type="filled" @click="createMeeting" :disabled="msg === '' || msg === null">Save</vs-button>
            </div>

          </div>
        </vs-popup>

        <!-- ADD EVENT -->
        <vs-prompt
            class="calendar-event-dialog"
            title="Add Event"
            accept-text= "Add Event"
            @accept="addEvent"
            :is-valid="validForm"
            :active.sync="activePromptAddEvent">

          <div class="calendar__label-container flex">

            <vs-chip v-if="labelLocal != 'none'" class="text-white" :class="'bg-' + labelColor(labelLocal)">{{ labelLocal }}</vs-chip>

            <vs-dropdown vs-custom-content vs-trigger-click class="ml-auto my-2 cursor-pointer">

              <feather-icon icon="TagIcon" svgClasses="h-5 w-5" class="cursor-pointer" @click.prevent></feather-icon>

              <vs-dropdown-menu style="z-index: 200001">
                <vs-dropdown-item v-for="(label, index) in calendarLabels" :key="index" @click="labelLocal = label.value">
                  <div class="h-3 w-3 inline-block rounded-full mr-2" :class="'bg-' + label.color"></div>
                  <span>{{ label.text }}</span>
                </vs-dropdown-item>

                <vs-dropdown-item @click="labelLocal = 'none'">
                  <div class="h-3 w-3 mr-1 inline-block rounded-full mr-2 bg-primary"></div>
                  <span>None</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>

          </div>

          <vs-input name="event-name" v-validate="'required'" class="w-full" label-placeholder="Event Title" v-model="title"></vs-input>
          <div class="my-4">
            <small class="date-label">Start Date</small>
            <datepicker :language="$vs.rtl ? langHe : langEn" name="start-date" v-model="startDate" :disabled="disabledFrom"></datepicker>
          </div>
          <div class="my-4">
            <small class="date-label">End Date</small>
            <datepicker :language="$vs.rtl ? langHe : langEn" :disabledDates="disabledDatesTo" name="end-date" v-model="endDate"></datepicker>
          </div>
          <vs-input name="event-url" v-validate="'url'" class="w-full mt-6" label-placeholder="Event URL" v-model="url" :color="!errors.has('event-url') ? 'success' : 'danger'"></vs-input>

        </vs-prompt>

        <!-- EDIT EVENT -->
        <vs-prompt
            class="calendar-event-dialog"
            title="Edit Event"
            accept-text= "Submit"
            cancel-text = "Remove"
            button-cancel = "border"
            @cancel="removeEvent"
            @accept="editEvent"
            :is-valid="validForm"
            :active.sync="activePromptEditEvent">

          <div class="calendar__label-container flex">

            <vs-chip v-if="labelLocal != 'none'" class="text-white" :class="'bg-' + labelColor(labelLocal)">{{ labelLocal }}</vs-chip>

            <vs-dropdown vs-custom-content class="ml-auto my-2 cursor-pointer">

              <feather-icon icon="TagIcon" svgClasses="h-5 w-5" @click.prevent></feather-icon>

              <vs-dropdown-menu style="z-index: 200001">
                <vs-dropdown-item v-for="(label, index) in calendarLabels" :key="index" @click="labelLocal = label.value">
                  <div class="h-3 w-3 inline-block rounded-full mr-2" :class="'bg-' + label.color"></div>
                  <span>{{ label.text }}</span>
                </vs-dropdown-item>

                <vs-dropdown-item @click="labelLocal = 'none'">
                  <div class="h-3 w-3 mr-1 inline-block rounded-full mr-2 bg-primary"></div>
                  <span>None</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>

          </div>

          <vs-input name="event-name" v-validate="'required'" class="w-full" label-placeholder="Event Title" v-model="title"></vs-input>
          <div class="my-4">
            <small class="date-label">Start Date</small>
            <datepicker :language="$vs.rtl ? langHe : langEn" :disabledDates="disabledDatesFrom" name="start-date" v-model="startDate"></datepicker>
          </div>
          <div class="my-4">
            <small class="date-label">End Date</small>
            <datepicker :language="$vs.rtl ? langHe : langEn" :disabledDates="disabledDatesTo" name="end-date" v-model="endDate"></datepicker>
          </div>
          <vs-input name="event-url" v-validate="'url'" class="w-full mt-6" label-placeholder="Event URL" v-model="url" :color="!errors.has('event-url') ? 'success' : 'danger'"></vs-input>

        </vs-prompt>
      </div>
    </vs-popup>
    <vs-table ref="table" multiple v-model="selected" pagination :max-items="itemsPerPage" :data="products">

      <template slot="thead">
        <vs-th sort-key="id">{{ $t("tblHeadings.th1") }}</vs-th>
        <vs-th sort-key="name">{{ $t("tblHeadings.th2") }}</vs-th>
        <vs-th sort-key="onboarding">{{ $t("tblHeadings.th7") }}</vs-th>
        <vs-th sort-key="monitoringFilter">{{ $t("tblHeadings.th8") }}</vs-th>
        <vs-th sort-key="feedbackInviteeCount">{{ $t("tblHeadings.th9") }}</vs-th>
        <vs-th sort-key="Feedback11"> {{ $t("coach.traineeList.tl5") }}</vs-th>

        <vs-th>    <vs-th sort-key="Feedback11">{{ $t("tblHeadings.th10") }}</vs-th></vs-th>
      </template>

        <template slot-scope="{data}">
<!--          {{data}}-->
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" v-if="tr.userData[0].status==='active'">
              <vs-td>

                <p class="product-name font-medium truncate">{{ tr.id }}</p>
              </vs-td>

               <vs-td>
                <p class="product-name font-medium truncate">{{ tr.userData[0].firstName }} {{ tr.userData[0].lastName }}</p>
              </vs-td>
              <vs-td>
                <feather-icon  v-if="tr.userData[0].isVerified===1" icon="CircleIcon" :title='$t("playerJourney.t1_1")' :svgClasses="['fill-current h-4 w-4', 'text-primary']" />
                <feather-icon v-else icon="CircleIcon"  :title='$t("playerJourney.t1_2")' :svgClasses="['fill-current h-4 w-4', 'text-grey']" />
                <feather-icon v-if="tr.skillCount>=1" class="ml-2" icon="CircleIcon"  :title='$t("playerJourney.t2_1")' :svgClasses="['fill-current h-4 w-4', 'text-primary']" />
                <feather-icon  v-else class="ml-2" icon="CircleIcon"  :title='$t("playerJourney.t2_2")' :svgClasses="['fill-current h-4 w-4', 'text-grey']" />
<!--                <feather-icon v-if="tr.developmentActionLength>=1" class="ml-2" title="Development Action Added" icon="CircleIcon" :svgClasses="['fill-current h-4 w-4', 'text-primary']" />-->
<!--                <feather-icon  v-else class="ml-2" icon="CircleIcon" title="Development Action Not Added" :svgClasses="['fill-current h-4 w-4', 'text-grey']" />-->
<!--                <feather-icon v-if="tr.feedbackInviteeCount>=1" class="ml-2" title="Has requested at least one feedback" icon="CircleIcon" :svgClasses="['fill-current h-4 w-4', 'text-primary']" />-->
<!--                <feather-icon  v-else class="ml-2" icon="CircleIcon" title="Has not requested at least one feedback" :svgClasses="['fill-current h-4 w-4', 'text-grey']" />-->
              </vs-td>
              <vs-td>
                <feather-icon v-if="tr.motivationSurvey===1" icon="CircleIcon" :title='$t("playerJourney.t3_1")' :svgClasses="['fill-current h-4 w-4', 'text-primary']" />
                <feather-icon v-else-if="tr.motivationSurvey===2" icon="CircleIcon"  :title='$t("playerJourney.t3_2")' :svgClasses="['fill-current nt h-4 w-4', 'text-warning']" />
                <feather-icon v-else icon="CircleIcon"  :title='$t("playerJourney.t3_3")' :svgClasses="['fill-current h-4 w-4', 'text-grey']" />
                <feather-icon v-if="tr.coachingSurvey===1" class="ml-2" icon="CircleIcon"  :title='$t("playerJourney.t4_1")' :svgClasses="['fill-current h-4 w-4', 'text-primary']" />
                <feather-icon v-else-if="tr.coachingSurvey===2" class="ml-2" icon="CircleIcon"  :title='$t("playerJourney.t4_2")' :svgClasses="['fill-current h-4 w-4', 'text-warning']" />
                <feather-icon v-else class="ml-2" icon="CircleIcon"  :title='$t("playerJourney.t4_3")' :svgClasses="['fill-current h-4 w-4', 'text-grey']" />
              </vs-td>
              <vs-td>
              <vs-button @click="editDataCoachingExpereince(tr.id)">Experience</vs-button>
                 </vs-td>

              <vs-td class="whitespace-no-wrap">
                <!--<feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editData(tr)" />-->
                <vs-button @click="editData(tr.userData[0].id)">{{ $t("coach.traineeList.tl7") }}</vs-button>
              </vs-td>

              <vs-td>
                <div class="flex">
                  <trainee-coach-notes v-bind:commuId="tr.userData[0].id" v-bind:key="'note-'+tr.userData[0].id" class="hover:text-primary"></trainee-coach-notes>
                  <!-- <img src="@/assets/images/elements/traineeProgress.svg" style="height:30px;" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                       @click="individualProgess(tr.userData[0].id)" alt="traineeProgress" title="Progess"> -->
                  <!-- <span style="font-size:1.2rem;" class="hover:text-primary cursor-pointer" 
                  @click="individualProgess(tr.userData[0].id)" alt="traineeProgress" title="Progess">
                    &#x1F4C5;
                  </span> -->
                 <feather-icon
                      icon="CalendarIcon"
                      svgClasses="ml-2 mr-1 hover:text-primary cursor-pointer"
                      @click="individualProgess(tr.userData[0].id)"
                      title="Progress"
                  />
                  <Todo :userId="tr.userData[0].id" v-bind:key="'todo-'+tr.userData[0].id" class="hover:text-primary"></Todo>
                </div>
              </vs-td>

            </vs-tr>
          </tbody>
        </template>
    </vs-table>
  </div>
</template>

<script>
import TraineeViewSidebar from './TraineeViewSidebar.vue'

import moduleDataList from '@/store/data-list/moduleDataList.js'
import FeatherIcon from '../../../../components/FeatherIcon.vue'
import Notes from '@/layouts/components/navbar/components/Notes.vue'
import Todo from '../../todo/Todo.vue'

import i18n from "@/i18n/i18n";
import CoachingExperienceSidebar from "./CoachingExperienceSidebar.vue";
import { CalendarView, CalendarViewHeader } from 'vue-simple-calendar'
import moduleCalendar from '@/store/calendar/moduleCalendar.js'
import Datepicker from 'vuejs-datepicker'
import { en, he } from 'vuejs-datepicker/src/locale'

import baseData from "@/i18n/i18n-en-Data-DPM.js";           
import deepData from "@/i18n/i18n-en-deep-Data.js";       
import pciData from "@/i18n/i18n-en-pci-Data-Coach.js";         
import peopletreeData from "@/i18n/i18n-en-peopletree-Data.js"; 

require('vue-simple-calendar/static/css/default.css')
export default {
  components: {
    TraineeViewSidebar,
    CoachingExperienceSidebar,
    CalendarView,
    CalendarViewHeader,
    FeatherIcon,
    Notes,
    Todo
  },
  data () {
    return {
      selected: [],
      // products: [],
      itemsPerPage: 20,
      isMounted: false,
      CCD: this.$t("addNewSkill.data"),
      skillsName:[],
      skillCount:'',
      data:[],
      length:0,
      count:0,
      // Data Sidebar
      calenderPopup:false,
      addNewDataSidebarCoaching:false,
      addNewDataSidebar: false,
      showDate: new Date(),
      disabledFrom: false,

      id: 0,
      title: '',
      startDate: '',
      endDate: '',
      labelLocal: 'none',

      langHe: he,
      langEn: en,
      eventsData:[],

      url: '',
      calendarView: 'week',

      calendarViewTypes: [
        { label: 'Week', val: 'week' },
        { label: 'Month', val: 'month' },
        { label: 'Year', val: 'year' }
      ],

     activePromptAddMeeting: false,
      currentTraineeId: null,
      currentTraineeName: '',
      meetingDate: new Date(),
      startH: 0,
      startM: 0,
      timezone: 'GMT',
      useMyMeetingLink: false,
      myMeetingLink: null,
      meetingUrl: '',
      msg: '',

      // sidebarData: 0
    }
  },



  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    products () {
      //console.log('all trainee list',this.$store.state.traineeCoachAssignment.traineeList);
        this.data=this.$store.state.traineeCoachAssignment.traineeList;


        console.log('all trainee list', this.data);
        for (let i = 0; i < this.data.length; i++) {
          this.$store.dispatch('addSkill/findCompetency', {query: {usersId: this.data[i].traineeId}})
            .then(res => {
              this.data[i].onboarding=0
              this.data[i].monitoringFilter=0;
              let markGoalCompleteCount = 0;
              let feedbackRequestedCount = 0;
              let developmentActionLength=0;

              console.log('res.data.length',res.data);
              for (let j = 0; j < res.data.length; j++) {
                this.data[i].goalCompleteCount = markGoalCompleteCount
                this.$store.dispatch('endorsement-invite/find', {query: {traineeCompetenciesId: res.data[j].id}})
                  .then(res => {
                    console.log('invitee data',res);
                    if (res.data.length !== 0) {
                      feedbackRequestedCount = developmentActionLength + res.data.length;
                    }
                    this.data[i].feedbackInviteeCount = feedbackRequestedCount
                  })
                  .catch(err => {
                  })
                this.$store.dispatch('development-actions/find', {query: {traineeCompetenciesId: res.data[j].id}})
                  .then(res => {
                    console.log('development-actions data',res);
                    if (res.data.length !== 0) {
                      developmentActionLength = developmentActionLength+res.data.length;
                    }
                    this.data[i].developmentActionLength = developmentActionLength
                  })
                  .catch(err => {
                  })
              }
              console.log('developmentActionLength',developmentActionLength)
              if (res.data[0].coachingSurveyDate !=null && res.data[0].progressStatus==='in_progress'){
                if(new Date() < new  Date(res.data[0].coachingSurveyDate)){
                  console.log('coaching Completed');
                  this.coachingSurveyDate=res.data[0].coachingSurveyDate;
                  this.data[i].coachingSurvey=1;
                }else if(new Date() > new Date(res.data[0].coachingSurveyDate)){
                  console.log('coaching overDue');
                  this.coachingSurveyDate=res.data[0].coachingSurveyDate;
                  const date1 = new Date(this.coachingSurveyDate);
                  const date2 = new Date();
                  const diffTime = Math.abs(date2 - date1);
                  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                  this.coachingOverdueCounter=diffDays;
                  //console.log(diffTime + " milliseconds");
                  console.log(diffDays + " days");
                  this.data[i].coachingSurvey=2;
                  //this.coachingSurveyStatus=2; //2 for overdue
                }
              }
              if (res.data[0].motivationSurveyDate !=null && res.data[0].progressStatus==='in_progress'){
                if(new Date() < new  Date(res.data[0].motivationSurveyDate)){
                  console.log('Completed');
                  this.motivationSurveyDate=res.data[0].motivationSurveyDate;
                  this.data[i].motivationSurvey=1;
                }else if(new Date() > new Date(res.data[0].motivationSurveyDate)){
                  console.log('overDue');
                  this.motivationSurveyDate=res.data[0].motivationSurveyDate;
                  const date1 = new Date(this.motivationSurveyDate);
                  const date2 = new Date();
                  const diffTime = Math.abs(date2 - date1);
                  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                  this.coachingOverdueCounter=diffDays;
                  //console.log(diffTime + " milliseconds");
                  console.log(diffDays + " days");
                  this.data[i].motivationSurvey=2;
                  //this.coachingSurveyStatus=2; //2 for overdue
                }
              }
              this.data[i].skillCount = res.data.length
              if(res.data.length===0){
                this.data[i].goalCompleteCount=0
                this.data[i].feedbackInviteeCount=0
              }else{
                // Get the specific user and their correct framework file
                const user = this.data[i].userData[0]; 
                const correctCCD = this.getFrameworkData(user);
                
                for(let k=0; k < res.data.length; k++){ 
                  const compId = res.data[k].competencyId; 
                  const characteristicId = compId.split("-")[0]; 
                  
                  // Look up inside the correct file (e.g. PCI Data)
                  const category = correctCCD[characteristicId];
                  const competencies = category ? category.competencies : [];
                  const currentCompetency = competencies.find(c => c.id === compId);
                  
                  if(currentCompetency && currentCompetency.comp) {
                    this.skillsName.push(currentCompetency.comp);
                  }
                }
              }
            })
            .catch(err => {
            })
        }
        return this.data;
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.products.length
    },
    simpleCalendarEvents () {
      return this.$store.state.calendar.events
    },
    validForm () {
      return this.title !== '' && this.startDate !== '' && this.endDate !== '' && Date.parse(this.endDate) - Date.parse(this.startDate) >= 0 && !this.errors.has('event-url')
    },
    disabledDatesTo () {
      return { to: new Date(this.startDate) }
    },
    disabledDatesFrom () {
      return { from: new Date(this.endDate) }
    },
    calendarLabels () {
      return this.$store.state.calendar.eventLabels
    },
    labelColor () {
      return (label) => {
        if      (label === 'business') return 'success'
        else if (label === 'work')     return 'warning'
        else if (label === 'personal') return 'danger'
        else if (label === 'none')     return 'primary'
      }
    },
    windowWidth () {
      return this.$store.state.windowWidth
    }
  },
  methods: {
    getFrameworkData(user) {
      // Replace 'framework' with the actual database field that stores the user's program type
      const type = user.framework || user.program || 'founder'; 
      
      if (['founder', 'pci'].includes(type.toLowerCase())) return pciData.addNewSkill.data;
      if (['behavioural', 'dpm'].includes(type.toLowerCase())) return baseData.addNewSkill.data;
      if (['ecosystem', 'deep'].includes(type.toLowerCase())) return deepData.addNewSkill.data;
      if (['performance', 'peopletree'].includes(type.toLowerCase())) return peopletreeData.addNewSkill.data;
      
      return this.$t("addNewSkill.data"); // fallback
    },
    // addNewData () {
    //   this.sidebarData = {}
    //   this.toggleDataSidebar(true)
    // },
    // deleteData (id) {
    //   this.$store.dispatch('dataList/removeItem', id).catch(err => { console.error(err) })
    // },
    individualProgess(id) {
      console.log('id', id);
      this.currentTraineeId = id; 
      this.showDate = new Date(); // <-- ADD THIS: Forces calendar to jump to today
      
      const traineeQuery = {
        status: { $ne: 'deleted' },
        userType: "trainee",
        id: id
      };
      
      this.calenderPopup = true; 

      this.$store
        .dispatch("userManagement/fetchUsers", { query: traineeQuery })
        .then(async (res) => {
          this.user_data = res;
          if (!res.data || res.data.length === 0) return;
          const trainee = res.data[0];
          
          // Store Name for meeting UI
          this.currentTraineeName = trainee.firstName + " " + (trainee.lastName || '');
          
          let eventData = [];

          try {
            // --- 1. EXISTING LOGIC: Fetch Trainee Competencies ---
            const traineeCompetencies = await this.$store.dispatch("trainee-competencies/find", {
              query: { usersId: id }
            });

            if (traineeCompetencies.data.length > 0) {
              const correctCCD = this.getFrameworkData(trainee);

              for (let j = 0; j < traineeCompetencies.data.length; j++) {
                const compId = traineeCompetencies.data[j].competencyId;
                const characteristicId = compId.split("-")[0];
                const category = correctCCD[characteristicId];
                const competencies = category ? category.competencies : [];
                const currentCompetency = competencies.find(c => c.id === compId);
                
                let skillName = currentCompetency ? currentCompetency.comp : "Unknown Skill";

                if (traineeCompetencies.data[j].progressStatus === 'in_progress') {
                  eventData.push({
                    title: trainee.firstName + " " + trainee.lastName + this.$t('calender.c1') + skillName + " .",
                    startDate: traineeCompetencies.data[j].createdAt,
                    endDate: traineeCompetencies.data[j].createdAt,
                    label: "none",
                    classes: "event-primary",
                    id: trainee.id
                  });
                } else if (traineeCompetencies.data[j].progressStatus === 'complete') {
                  eventData.push({
                    title: this.$t('calender.c2') + skillName + this.$t('calender.c3') + trainee.firstName + " " + trainee.lastName + " .",
                    startDate: traineeCompetencies.data[j].updatedAt,
                    endDate: traineeCompetencies.data[j].updatedAt,
                    label: "none",
                    classes: "event-success",
                    id: trainee.id
                  });
                }
              }
            } else {
              eventData.push({
                title: trainee.firstName + " " + trainee.lastName + this.$t('calender.c4'),
                startDate: trainee.createdAt,
                endDate: trainee.createdAt,
                label: "none",
                classes: "event-danger",
                id: trainee.id
              });
            }

            // --- 2. NEW LOGIC: Fetch Meetings (Notes) between Coach and Trainee ---
            const coachId = this.$store.state.AppActiveUser.usersId;
            const meetingQuery = {
              $and: [
                { authorId: { $in: [coachId, id] } },
                { commuId: { $in: [coachId, id] } },
                { noteType: 4 }, // Type 4 is meeting schedule
                { status: 0 } // Active records
              ]
            };

            const meetingsData = await this.$store.dispatch("notesManagement/fetchNotes", { query: meetingQuery });
            if (meetingsData && meetingsData.data) {
              meetingsData.data.forEach(meeting => {
                if (meeting.meetingDate) {
                  // Attempt to parse meeting link to make calendar event clickable if supported
                  let link = "";
                  if (meeting.message && meeting.message.includes("href=")) {
                    const match = meeting.message.match(/href="([^"]*)"/);
                    if (match) link = match[1];
                  }

                  eventData.push({
                    title: "Meeting: " + trainee.firstName,
                    startDate: meeting.meetingDate,
                    endDate: meeting.meetingDate, 
                    label: "business", 
                    classes: "event-warning", // Orange/Warning color distinguishes meetings
                    url: link,
                    id: meeting.id || meeting._id
                  });
                }
              });
            }

            // Apply all events to calendar
            this.eventsData = [...new Set(eventData)];

          } catch (err) {
            console.error(err);
          }
        })
        .catch(err => {
          if (err.response && err.response.status === 404) {
            this.user_not_found = true;
            return;
          }
          console.error("Error fetching trainee for calendar:", err);
        });
    },
    promptAddMeeting(date) {
      const clickedDate = new Date(date);
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Reset time to midnight for accurate day comparison

      // Prevent scheduling in the past
      if (clickedDate < today) {
        this.$vs.notify({ 
          title: "Invalid Date", 
          text: "You cannot schedule a meeting on a past date.", 
          color: "warning" 
        });
        return; // Stop execution, don't open popup
      }

      this.meetingUrl = '';
      this.msg = '';
      this.useMyMeetingLink = false;
      this.meetingDate = clickedDate; 
      
      const now = new Date();
      this.startH = now.getHours();
      this.startM = (now.getMinutes() + 5) % 60;
      
      this.activePromptAddMeeting = true; 
    },
    
    async createMeeting() {
      const d = new Date(this.meetingDate);
      const startD = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
      
      const formattedHour = String(this.startH).padStart(2, '0');
      const formattedMinute = String(this.startM).padStart(2, '0');
      const schedule_time = `${startD} ${formattedHour}:${formattedMinute}:00`;

      let finalMeetingUrl = this.useMyMeetingLink ? this.myMeetingLink : this.meetingUrl;
      let finalMessage = this.msg;
      if (finalMeetingUrl) {
        finalMessage = this.msg + '<br><br>📍 <strong>Meeting Link:</strong> ' + finalMeetingUrl;
      }

      const note = {
        userRole: this.$store.state.AppActiveUser.userType,
        noteType: 4,
        authorId: this.$store.state.AppActiveUser.usersId,
        commuId: this.currentTraineeId, 
        company: window.$cookies.get('companyName'),
        loginType: this.$store.state.AppActiveUser.userType,
        message: finalMessage,
        timezone: this.timezone,
        status: 0,
        meetingDate: schedule_time
      };

      try {
        const res = await this.$store.dispatch("notesManagement/addNote", note);
        this.$vs.notify({ title: "Success", text: "Meeting Scheduled Successfully", color: "success" });
        
        // Exact text format you requested
        const meetingTitle = `🗓️ Meeting scheduled with ${this.currentTraineeName} at ${formattedHour}:${formattedMinute}`;
        
        const newEvent = {
          title: meetingTitle,
          startDate: schedule_time,
          endDate: schedule_time,
          label: "business",
          classes: "event-warning",
          id: res.id || res._id
        };

        // Use array spread to FORCE Vue to re-render the calendar immediately
        this.eventsData = [...this.eventsData, newEvent];
        
        this.activePromptAddMeeting = false;
      } catch (err) {
        console.error(err);
        this.$vs.notify({ title: "Failed", text: "Failed to schedule meeting", color: "danger" });
      }
    },
    editDataCoachingExpereince(id){

      this.$store
        .dispatch("coachingExperience/setSidebarId", id)
        .then(res => {
          this.toggleDataSidebarCoaching(true);
        });
    },
    toggleDataSidebarCoaching(val = false) {
      if (val === false) {
        this.$store
          .dispatch("coachingExperience/setSidebarId", 0)
          .then(res => {});
      }
      console.log('editDataCoachingExpereince',val);
      this.addNewDataSidebarCoaching = val;
    },

    editData (id) {
      //this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.sidebarData = id
      this.$store.dispatch("traineeCoachAssignment/setSidebarId", id).then(res => {
        console.log(res);
        this.toggleDataSidebar(true)
      })
    },
    toggleDataSidebar (val = false) {
      if(val === false) {
        this.$store.dispatch("traineeCoachAssignment/setSidebarId", 0).then(res => {})
      }
      this.addNewDataSidebar = val
    },
    addEvent () {
      const obj = { title: this.title, startDate: this.startDate, endDate: this.endDate, label: this.labelLocal, url: this.url }
      obj.classes = `event-${  this.labelColor(this.labelLocal)}`
      this.$store.dispatch('calendar/addEvent', obj)
    },
    updateMonth (val) {
      this.showDate = this.$refs.calendar.getIncrementedPeriod(val)
    },
    clearFields () {
      this.title = this.endDate = this.url = ''
      this.id = 0
      this.labelLocal = 'none'
    },
    promptAddNewEvent (date) {
      this.disabledFrom = false
      this.addNewEventDialog(date)
    },
    addNewEventDialog (date) {
      this.clearFields()
      this.startDate = date
      this.endDate = date
      this.activePromptAddEvent = true
    },
    openAddNewEvent (date) {
      this.disabledFrom = true
      this.addNewEventDialog(date)
    },

    editEvent () {
      const obj = { id: this.id, title: this.title, startDate: this.startDate, endDate: this.endDate, label: this.labelLocal, url: this.url }
      obj.classes = `event-${  this.labelColor(this.labelLocal)}`
      this.$store.dispatch('calendar/editEvent', obj)
    },
    removeEvent () {
      this.$store.dispatch('calendar/removeEvent', this.id)
    },
    eventDragged (event, date) {
      this.$store.dispatch('calendar/eventDragged', {event, date})
    }
  },
  beforeDestroy () {
    this.$store.unregisterModule('calendar')
  },
  created () {
    //  if (!moduleDataList.isRegistered) {
    //   this.$store.registerModule('dataList', moduleDataList)
    //   moduleDataList.isRegistered = true
    // }
    this.$store.registerModule('calendar', moduleCalendar)
    const coachId = this.$store.state.AppActiveUser.usersId
    let query={}
    if(coachId===1){
      query={query: {status:'active'}}
    }
    else {
      query={query: {coachId,status:'active'}}
    }
    console.log('coachId',coachId);
    this.$store.dispatch('traineeCoachAssignment/fetchTrainees',query)
      .then(res => {
       if(res.length > 0) {
          console.log("all trainee data", res.data);
        }
      })
      .catch(err => console.error("Could not fetch trainees", err));
      this.$store.dispatch("userManagement/fetchUser", this.$store.state.AppActiveUser.usersId)
      .then(res => {
        this.myMeetingLink = res.meetingLink || res.meetingUrl || null; 
      }).catch(err => console.error("Could not fetch personal meeting link", err));
  },
  mounted () {
    this.isMounted = true
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/simple-calendar.scss";
#data-list-list-view {
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
.fix-label {
  width: 145px;
  min-width: 145px;
}
.bg-none, #weekend-datetime-picker {
  background: transparent;
}
.meeting-popup .vdp-datepicker__calendar {
   right: 0px;
}

/* Force popup to sit on top of everything including the fullscreen popup */
.meeting-popup .vs-popup {
  z-index: 9999999 !important;
  overflow: visible !important;
}

/* Allow dropdowns inside popup to overflow correctly */
.meeting-popup .vs-popup--content {
  overflow: visible !important;
  padding-bottom: 20px;
}

.custom-calendar-view .cv-day {
  cursor: pointer;
}
.custom-calendar-view .cv-day:hover {
  background-color: rgba(0, 0, 0, 0.03);
}
.custom-calendar-view .cv-day.today {
  background-color: rgba(var(--vs-primary), 0.08) !important;
  border: 2px solid rgba(var(--vs-primary), 0.8) !important;
}

.custom-calendar-view .cv-day.today .cv-day-number {
  font-weight: 800 !important;
  color: rgba(var(--vs-primary), 1) !important;
  background-color: white;
  border-radius: 50%;
  padding: 2px 6px;
}
</style>

<!--<template>-->
<!--  <div id="data-list-list-view" class="data-list-container">-->

<!--    <trainee-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" />-->

<!--    <vs-table ref="table" multiple v-model="selected" pagination :max-items="itemsPerPage" :data="products">-->

<!--      <template slot="thead">-->
<!--        <vs-th sort-key="id">{{ $t("coach.traineeList.tl1") }}</vs-th>-->
<!--        <vs-th sort-key="name">{{ $t("coach.traineeList.tl2") }}</vs-th>-->
<!--        <vs-th sort-key="email">{{ $t("coach.traineeList.tl3") }}</vs-th>-->
<!--        <vs-th>{{ $t("coach.traineeList.tl4") }}</vs-th>-->
<!--      </template>-->

<!--      <template slot-scope="{data}">-->
<!--        <tbody>-->
<!--        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">-->

<!--          <vs-td>-->
<!--            <p class="product-name font-medium truncate">{{ tr.id }}</p>-->
<!--          </vs-td>-->

<!--          <vs-td>-->
<!--            <p class="product-name font-medium truncate">{{ tr.userData[0].firstName }} {{ tr.userData[0].lastName }}</p>-->
<!--          </vs-td>-->

<!--          <vs-td>-->
<!--            <p class="product-name font-medium truncate">{{ tr.userData[0].email }}</p>-->
<!--          </vs-td>-->

<!--          <vs-td class="whitespace-no-wrap">-->
<!--            &lt;!&ndash;<feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editData(tr)" />&ndash;&gt;-->
<!--            <vs-button @click="editData(tr.userData[0].id)">{{ $t("coach.traineeList.tl5") }}</vs-button>-->
<!--          </vs-td>-->

<!--        </vs-tr>-->
<!--        </tbody>-->
<!--      </template>-->
<!--    </vs-table>-->
<!--  </div>-->
<!--</template>-->

<!--<script>-->
<!--  import TraineeViewSidebar from './TraineeViewSidebar.vue'-->
<!--  import moduleDataList from '@/store/data-list/moduleDataList.js'-->

<!--  export default {-->
<!--    components: {-->
<!--      TraineeViewSidebar-->
<!--    },-->
<!--    data () {-->
<!--      return {-->
<!--        selected: [],-->
<!--        // products: [],-->
<!--        itemsPerPage: 100,-->
<!--        isMounted: false,-->

<!--        // Data Sidebar-->
<!--        addNewDataSidebar: false,-->
<!--        // sidebarData: 0-->
<!--      }-->
<!--    },-->
<!--    computed: {-->
<!--      currentPage () {-->
<!--        if (this.isMounted) {-->
<!--          return this.$refs.table.currentx-->
<!--        }-->
<!--        return 0-->
<!--      },-->
<!--      products () {-->
<!--        return this.$store.state.traineeCoachAssignment.traineeList-->
<!--      },-->
<!--      queriedItems () {-->
<!--        return this.$refs.table ? this.$refs.table.queriedResults.length : this.products.length-->
<!--      }-->
<!--    },-->
<!--    methods: {-->
<!--      /*addNewData () {-->
<!--        this.sidebarData = {}-->
<!--        this.toggleDataSidebar(true)-->
<!--      },*/-->
<!--      /*deleteData (id) {-->
<!--        this.$store.dispatch('dataList/removeItem', id).catch(err => { console.error(err) })-->
<!--      },*/-->
<!--      editData (id) {-->
<!--        // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))-->
<!--        // this.sidebarData = id-->
<!--        this.$store.dispatch("traineeCoachAssignment/setSidebarId", id).then(res => {-->
<!--          this.toggleDataSidebar(true)-->
<!--        })-->
<!--      },-->
<!--      toggleDataSidebar (val = false) {-->
<!--        if(val === false) {-->
<!--          this.$store.dispatch("traineeCoachAssignment/setSidebarId", 0).then(res => {})-->
<!--        }-->
<!--        this.addNewDataSidebar = val-->
<!--      }-->
<!--    },-->
<!--    created () {-->
<!--      if (!moduleDataList.isRegistered) {-->
<!--        this.$store.registerModule('dataList', moduleDataList)-->
<!--        moduleDataList.isRegistered = true-->
<!--      }-->
<!--      const coachId = this.$store.state.AppActiveUser.usersId-->
<!--      this.$store.dispatch('traineeCoachAssignment/fetchTrainees', {query: {coachId}})-->
<!--        .then(res => {-->
<!--          if(res.total > 0) {-->
<!--            console.log("all trainee data", res.data);-->
<!--          }-->
<!--        })-->
<!--        .catch(err => {})-->
<!--    },-->
<!--    mounted () {-->
<!--      this.isMounted = true-->
<!--    }-->
<!--  }-->
<!--</script>-->

<!--<style lang="scss">-->
<!--  #data-list-list-view {-->
<!--    .vs-con-table {-->

<!--      /*-->
<!--        Below media-queries is fix for responsiveness of action buttons-->
<!--        Note: If you change action buttons or layout of this page, Please remove below style-->
<!--      */-->
<!--      @media (max-width: 689px) {-->
<!--        .vs-table&#45;&#45;search {-->
<!--          margin-left: 0;-->
<!--          max-width: unset;-->
<!--          width: 100%;-->

<!--          .vs-table&#45;&#45;search-input {-->
<!--            width: 100%;-->
<!--          }-->
<!--        }-->
<!--      }-->

<!--      @media (max-width: 461px) {-->
<!--        .items-per-page-handler {-->
<!--          display: none;-->
<!--        }-->
<!--      }-->

<!--      @media (max-width: 341px) {-->
<!--        .data-list-btn-container {-->
<!--          width: 100%;-->

<!--          .dd-actions,-->
<!--          .btn-add-new {-->
<!--            width: 100%;-->
<!--            margin-right: 0 !important;-->
<!--          }-->
<!--        }-->
<!--      }-->

<!--      .product-name {-->
<!--        max-width: 23rem;-->
<!--      }-->

<!--      .vs-table&#45;&#45;header {-->
<!--        display: flex;-->
<!--        flex-wrap: wrap;-->
<!--        margin-left: 1.5rem;-->
<!--        margin-right: 1.5rem;-->
<!--        > span {-->
<!--          display: flex;-->
<!--          flex-grow: 1;-->
<!--        }-->

<!--        .vs-table&#45;&#45;search{-->
<!--          padding-top: 0;-->

<!--          .vs-table&#45;&#45;search-input {-->
<!--            padding: 0.9rem 2.5rem;-->
<!--            font-size: 1rem;-->

<!--            &+i {-->
<!--              left: 1rem;-->
<!--            }-->

<!--            &:focus+i {-->
<!--              left: 1rem;-->
<!--            }-->
<!--          }-->
<!--        }-->
<!--      }-->

<!--      .vs-table {-->
<!--        border-collapse: separate;-->
<!--        border-spacing: 0 1.3rem;-->
<!--        padding: 0 1rem;-->

<!--        tr{-->
<!--          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);-->
<!--          td{-->
<!--            padding: 20px;-->
<!--            &:first-child{-->
<!--              border-top-left-radius: .5rem;-->
<!--              border-bottom-left-radius: .5rem;-->
<!--            }-->
<!--            &:last-child{-->
<!--              border-top-right-radius: .5rem;-->
<!--              border-bottom-right-radius: .5rem;-->
<!--            }-->
<!--          }-->
<!--          td.td-check{-->
<!--            padding: 20px !important;-->
<!--          }-->
<!--        }-->
<!--      }-->

<!--      .vs-table&#45;&#45;thead{-->
<!--        th {-->
<!--          padding-top: 0;-->
<!--          padding-bottom: 0;-->

<!--          .vs-table-text{-->
<!--            text-transform: uppercase;-->
<!--            font-weight: 600;-->
<!--          }-->
<!--        }-->
<!--        th.td-check{-->
<!--          padding: 0 15px !important;-->
<!--        }-->
<!--        tr{-->
<!--          background: none;-->
<!--          box-shadow: none;-->
<!--        }-->
<!--      }-->

<!--      .vs-table&#45;&#45;pagination {-->
<!--        justify-content: center;-->
<!--      }-->
<!--    }-->
<!--  }-->
<!--</style>-->
